up.on('up:location:changed', () => {
  if (typeof Intercom === "function") {
    Intercom('update');
  }
})